import NoListItems from "../../Custom/NoListItems";
import DashCard from "./DashCard";
import { ListItem } from "./ExamMetrics";

const FlashMetrics = ({ metrics }) => {
  const isMetricsEmpty = metrics?.every((metric) => metric.value === 0);
  return (
    <DashCard
      title="Flashcard Metrics"
      cornerContent=""
      children={
        isMetricsEmpty ? (
          <NoListItems text="No metrics available" />
        ) : (
          <ul className="metrics">
            {metrics.map((metric) => {
              return (
                <ListItem
                  label={metric.title}
                  value={metric.value}
                  key={`metric-${metric.title}`}
                />
              );
            })}
          </ul>
        )
      }
    />
  );
};

export default FlashMetrics;
